/**
 * Bewertungskriterien je bewerteter Rolle (je 1–5 Sterne).
 *
 * - PB wird von einer BK bewertet → Tabelle ratings_bk.
 * - BK wird vom Kunden (PB) bewertet → Tabelle ratings. Ticket 13.10.2026:
 *   Erscheinungsbild, Aufgeschlossenheit, Zusammenarbeit, Kompetenz,
 *   Haushalt, Sprachkenntnisse. „Zusammenarbeit" ersetzt das frühere
 *   „Kommunikation" und wird in derselben Spalte rating_kommunikation
 *   gespeichert (v1-API und CRM 1.0 bleiben unverändert).
 *
 * `key` = i18n-Schlüssel unter pflege.ratings.create.criteria, `field` =
 * Spalte/Payload-Feld der v1-API.
 */
export interface RatingCriterion {
  key: string;
  field: string;
}

export const PB_RATING_CRITERIA = [
  { key: 'wohnqualitaet', field: 'rating_wohnqualitaet' },
  { key: 'charakter', field: 'rating_charakter' },
  { key: 'pflegeaufwand', field: 'rating_pflegeaufwand' },
  { key: 'umfeld', field: 'rating_umfeld' },
  { key: 'freizeit', field: 'rating_freizeit' },
] as const satisfies readonly RatingCriterion[];

export const BK_RATING_CRITERIA = [
  { key: 'erscheinungsbild', field: 'rating_erscheinungsbild' },
  { key: 'aufgeschlossenheit', field: 'rating_aufgeschlossenheit' },
  { key: 'zusammenarbeit', field: 'rating_kommunikation' },
  { key: 'kompetenz', field: 'rating_kompetenz' },
  { key: 'haushalt', field: 'rating_haushalt' },
  { key: 'sprachkenntnisse', field: 'rating_sprachkenntnisse' },
] as const satisfies readonly RatingCriterion[];

/** Kriterien passend zur bewerteten Rolle (1 = BK, sonst PB). */
export function criteriaForRatedRole(userRole: number | null | undefined): readonly RatingCriterion[] {
  return Number(userRole) === 1 ? BK_RATING_CRITERIA : PB_RATING_CRITERIA;
}

/**
 * Kriterien einer geladenen Bewertungszeile — erkannt an ihren Spalten, damit
 * erhaltene und geschriebene Bewertungen gleich dargestellt werden.
 */
export function criteriaForRow(row: Record<string, unknown>): readonly RatingCriterion[] {
  if (row.rating_erscheinungsbild != null) return BK_RATING_CRITERIA;
  if (row.rating_wohnqualitaet != null) return PB_RATING_CRITERIA;
  return [];
}
